import { useQuery } from "@apollo/client";
import { GET_TODOS } from "apollo";
import { LoadingLayout, PageLayout, Separator, Text } from "components";
import { TodosResponse, T_Todo } from "types";
import { TodoItem, TodoDrawer } from "../components";
import { TodoContainerStyle } from "../styles";
import { useState } from "react";

export const TodoScreen = () => {
  const { data: todoData, loading } = useQuery<TodosResponse>(GET_TODOS);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<T_Todo | null>(null);

  const handleOpenDrawer = (task: T_Todo) => {
    setSelectedTask(task);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedTask(null);
  };

  if (loading) {
    return <LoadingLayout />;
  }
  const todos = todoData?.todos || [];
  return (
    <PageLayout title="Action Items | Multiplayer">
      <div className={TodoContainerStyle}>
        <Text.H3>For you</Text.H3>
        <Separator.Horizontal spacing={8} />
        {!loading && todos?.length === 0 && (
          <Text.Body>
            No tasks for you yet. Actions items and reminders will be
            automatically captured for you here.
          </Text.Body>
        )}
        {todos.map((todo) => (
          <TodoItem
            key={todo._id}
            task={todo}
            onOpenDrawer={handleOpenDrawer}
          />
        ))}
      </div>
      <TodoDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        task={selectedTask}
      />
    </PageLayout>
  );
};
